import React from "react";
import { Route, Routes } from "react-router-dom";

import ExpressReport from "js/pages/ExpressReport/ExpressReport";
import NotFound from "js/pages/NotFound";
import MultireportView from "js/pages/Reports/MultireportView";

const Report = () => {
  return (
    <Routes>
      <Route path="multireport/:token" element={<MultireportView />} />
      <Route path="multireport" element={<MultireportView />} />
      <Route path=":investigationId" element={<ExpressReport />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Report;
